/* Dialog Text */
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import { MatDialog } from "@angular/material/dialog";
import {
  PartnerEmbedAdminDetails,
  Interacts,
  ReportPageDefinition, PartnerEmbedPageRestriction
} from "../../../api/models";
import {AdminInteractiveService} from "../../../api/services/admin-interactive.service";
import {DeepCopy} from "../../../api/models-ex/deep-copy";
import {InteractivesService} from "../../../api/services/interactives.service";
import { PreFilterService } from "../../../api/services";

export interface EditPartnerEmbedData {
  dialogTitle: string;
  isNew: boolean;
  partnerEmbed: PartnerEmbedAdminDetails,
}

@Component({
  selector: "edit-partner-embed-dialog",
  styleUrls: ["edit-partner-embed-dialog.component.css"],
  templateUrl: "./edit-partner-embed-dialog.component.html",
})
export class EditPartnerEmbedDialogComponent {
  public Result: DialogResult;
  public targetEmbed: PartnerEmbedAdminDetails = {
    allowRemoteFiltering: false,
    interactId: 0,
    name: '',
    preFiltersApplied: false,
    enabled: true,
    partnerEmbedId: 0,
    partnerEmbedKey: '00000000-0000-0000-0000-000000000000',
    interactiveName: '',
    startPage: '',
    preFilters: [],
    pageRestrictions: [],
    preFilterId: 0
  };

  public allInteracts: Interacts[] = [];

  public interactPages: ReportPageDefinition[] = [];
  public pageRestrictions: PartnerEmbedPageRestriction[] = [];

  public selectedPage: ReportPageDefinition;

  public preFilterId: number = 0;

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<EditPartnerEmbedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditPartnerEmbedData,
    public adminInteractiveService: AdminInteractiveService,
    public preFilterService: PreFilterService,
    public interactiveService: InteractivesService,
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
    adminInteractiveService.adminInteractiveGetInteractives().subscribe(result => {
      this.allInteracts = result;

      if (!this.data.isNew) {
        this.targetEmbed = DeepCopy.copy(this.data.partnerEmbed);
        this.updateInteractiveData();
        this.preFilterId = this.targetEmbed.preFilterId;
      } else {
        this.preFilterService.preFilterCreatePreFilter({
          name: "PartnerEmbed",
          preFilterId: 0,
          isDefault: false,
          userId: 0,
          deleted: false
        }).subscribe(result => {
          this.preFilterId = result.preFilterId;
        });
      }
    });
  }

  onCancelClick(): void {
    if (this.data.isNew) {
      this.preFilterService.preFilterDeletePreFilterByid(this.preFilterId).subscribe(_ => {});
    }
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.targetEmbed.pageRestrictions = this.pageRestrictions;
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = {
      targetEmbed: this.targetEmbed,
      preFilterId: this.preFilterId
    };
    this.dialogRef.close(this.Result);
  }

  updateInteractiveData() {
    /*this.preFilterInteractiveService.preFilterInteractivesGetInteractivePreFilterKeys(this.targetEmbed.interactId).subscribe(result => {
      this.preFilterKeys = result;
    });*/

    this.interactiveService.interactivesGetInteractivePages(this.targetEmbed.interactId).subscribe(result => {
      this.interactPages = result;
    });

    //this.preFilters = [];
    this.pageRestrictions = [];
    if (this.data.partnerEmbed.interactId == this.targetEmbed.interactId) {
      //this.preFilters = DeepCopy.copy(this.data.partnerEmbed.preFilters);
      this.pageRestrictions = DeepCopy.copy(this.data.partnerEmbed.pageRestrictions);
    }

    return false;
  }

  addPageRestriction() {
    if (!this.pageRestrictions.find(x => x.page === this.selectedPage.name)) {
      this.pageRestrictions.push({
        page: this.selectedPage.name,
        displayName: this.selectedPage.displayName,
        partnerEmbedId: 0,
        partnerEmbedPageRestrictionId: 0
      });
    }
    return false;
  }

  removePageRestriction(idx: number) {
    this.pageRestrictions.splice(idx, 1);
    return false;
  }

  /*editPreFilterValues(): void {
    PreFilterEditorDialogComponent.showDialog(this.dialog, this.preFilterId).subscribe(result => {

    });
  }*/
}
